import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Icon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledContentContainer = styled.div`
  padding: ${convertUnit(20)};
  margin: ${convertUnit(20)};
  border: ${convertUnit(1)} dashed ${({theme}) => theme.gray_5};
  border-radius: ${convertUnit(8)};
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${convertUnit(8)};
`
const StyledButton = styled(Button)`
  width: 100%;
  margin-top: ${convertUnit(8)};
`
interface GiftShopEditProfileSelfieLandingProps {
  onClick(): void
}

export default function GiftShopEditProfileSelfieLanding({
  onClick,
}: GiftShopEditProfileSelfieLandingProps) {
  const {translate} = useTranslation()
  return (
    <StyledContentContainer>
      <Icon type="face-scan" color="gray_5" size={32} />
      <Paragraph fontSize="m" fontWeight="medium" color="gray_5">
        {translate('giftShop:editCredentialSelfieLandingTitle')}
      </Paragraph>
      <Paragraph fontWeight="medium" color="gray_5">
        {translate('giftShop:editCredentialSelfieLandingMessage')}
      </Paragraph>
      <StyledButton
        label={translate('giftShop:retakeKYC')}
        type="small"
        fontSize="s"
        onClick={onClick}
      />
    </StyledContentContainer>
  )
}
